import { useMutation, useQueryClient } from '@tanstack/react-query';

import { UserUpdateMessage } from '../../../../types/UserUpdateMessage';
import { updateUser } from '../../../common/api/clients/user.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useUserUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (user: UserUpdateMessage) => {
            return updateUser(user);
        },

        onSuccess: () => {
            return queryClient.invalidateQueries({ queryKey: queries.members._def });
        },
    });
};
